'use strict';

var React = require('react');

function _interopNamespaceDefault(e) {
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n.default = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgFileSlash = function SvgFileSlash(props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    fill: "",
    fillRule: "evenodd",
    d: "m19.928 8.652.009.028q.042.125.05.258.001.015.007.029A.1.1 0 0 1 20 9v9.586l1.71 1.71-1.414 1.414-18-18L3.71 2.296l.614.614A2 2 0 0 1 6 2h7q.017 0 .033.006.014.005.029.007a1 1 0 0 1 .259.051l.03.01q.033.01.064.023a1 1 0 0 1 .293.196l6 6a1 1 0 0 1 .22.359M6 4.586V4h6v5a1 1 0 0 0 1 1h5l.002 6.588zM14 8h2.586L14 5.414zM4 20V8.121l2 2V20h10l2 2H6c-1.103 0-2-.897-2-2",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSlash);

module.exports = ForwardRef;
